'<template>
  <div class="knowlarity">
    <div class="col-md-12 my-2 mb-4 p-0 d-flex">
      <div class="mx-2">
        <input type="text" class="form-control mr-4" placeholder="search through table" />
      </div>
      <div class="mx-2">
        <select
        @change="fetchknowlarityData"
        class="form-control"
        v-model="filterAgent"
        name=""
        id=""
      >
        <option value="all">All Agents</option>
        <option v-for="(data, index) in agents" :key="index" :value="data.phone"
          >{{ data.first_name }}
          <span class="badge badge-success"> -{{ data.phone }}</span>
        </option>
      </select>
      </div>
      <div class="mx-2">
        Start Date:
        <label for="startDate">   
          <input type="date" class="form-control" @change="fetchknowlarityData"  v-model="startDate">
        </label>  
      </div>
      <div class="mx-2">
          End Date:
        <label for="startDate">
          <input type="date" class="form-control" @change="fetchknowlarityData" v-model="endDate">
        </label>
      </div>
      <div class="mx-2">
        <select name="" v-model="limit" @change="fetchknowlarityData" class="form-control" id="">
          <option disabled value="">Limit</option>
          <option value="50">50</option>
          <option value="70">70</option>
          <option value="100">100</option>
          <!-- <option value="500">All</option> -->
        </select>
      </div>
    </div>
    <div v-if="startDate && endDate" class="card col-md-12 p-2 mb-5">
      <div class="col-md-12 p-0 m-0">
        <p>
          <strong>Total of {{ filterByAgent.length }}/ {{knowlarityCount.total_count}} data found.</strong>
        </p>
      </div>
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr style="">
              <th>Date</th>
              <th>Customer Number</th>
              <th>Call Type</th>
              <!-- <th>Call Duration</th> -->
              <th>Recording</th>
              <!-- <th>Time</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in filterByAgent" :key="index">
              <td>{{ data.start_time | moment("LLL") }}</td>
              <td>{{ data.customer_number }}</td>
              <!-- <td>{{ data.agent_number || "-" }} 
                <span class="badge badge-info">{{searchAgent(data.agent_number)}}</span>
            </td> -->
              <td>
                <span v-if="data.Call_Type == 0" class="badge badge-primary"
                  >Incoming</span
                >
                <span v-if="data.Call_Type == 1" class="badge badge-secondary"
                  >Outgoing</span
                >
              </td>
              <!-- <td>{{ data.call_duration }}</td> -->
              <td>
                <!-- <a  v-if="data.call_recording" @click="play(data.call_recording)" class="hover py-1 px-2" 
                  ><i class="fa fa-microphone" aria-hidden="true"></i
                ></a>
                <a v-else
                  ><i class="fa fa-microphone-slash" aria-hidden="true"></i
                ></a> -->
                <audio controls class="p-0" style="margin: 0 auto;">
                    <source :src="data.call_recording" type="audio/mpeg">
                    Your browser does not support the audio element.
                </audio>

              </td>
              <!-- <td style="white-space: nowrap;">
                {{ data.start_time | moment("LLL") }}
              </td> -->
            </tr>
          </tbody>
        </table>
        <div>
          <button class="btn btn-primary btn-sm" v-if="limit != knowlarityCount.total_count && knowlarityCount.total_count >24" @click="next">Load More</button>
        </div>
        <div
          class="col-md-12 m-0 p-0 p-5 text-center"
          v-if="filterByAgent.length == 0 && !loading"
        >
          <p>No records found for this agent</p>
        </div>
      </div>
    </div>
    <div v-else class="card p-4">
        <p>Please insert date and agent to begin!</p>
    </div>
    <div class="col-md-12 m-0 p-0 mt-5 text-center" v-if="loading">
      Loading..
    </div>

    <!-- <button type="button" class="btn btn-primary" data-toggle="modal" data-target=".bd-example-modal-md">Small modal</button> -->

<!-- <div class="modal fade bd-example-modal-md" @click="stop" v-if="currentPlaying" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content p-4" style="font-size:25px">
      <audio controls autoplay style="margin: 0 auto;">
        <source :src="currentPlaying" type="audio/mpeg">
        Your browser does not support the audio element.
      </audio>
    </div>
  </div>
</div> -->

<div class="player col-md-4 card py-2" v-if="currentPlaying">
  <div class="text-right close-btn" @click="stop">
    <i style="border-radius:50%;color:white" class="fa fa-times p-2"></i>
  </div>
  <audio controls class="p-0" autoplay style="margin: 0 auto;">
        <source :src="currentPlaying" type="audio/mpeg">
        Your browser does not support the audio element.
    </audio>
</div>


  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      endDate: null,
      filterAgent: 0,
      startDate: null,
      limit: 20,
      currentPlaying:null
    };
  },
  mounted() {
    this.fetch();
  },
  watch: {
    agents() {
      this.filterAgent = this.agents[0].phone;
      this.fetchknowlarityData();
    },
  },
  created(){
    window.addEventListener("play", function(evt)
    {
        if(window.$_currentlyPlaying)
        {
            window.$_currentlyPlaying.pause();
        } 
        else if(window.$_currentlyPlaying == evt.target){
          window.$_currentlyPlaying.play();
        }
        window.$_currentlyPlaying = evt.target;
        console.log(evt)
    }, true); 
  },
  methods: {
    fetch() {
      this.$store.dispatch("get_Knowlarity_agents");
    },
    next(){
      if (this.knowlarityCount.total_count - this.limit > 20){
        this.limit += 20
        this.fetchknowlarityData()
      }else{
        this.limit = this.knowlarityCount.total_count
        this.fetchknowlarityData()
      }
    },
    fetchknowlarityData() {
      if(this.startDate && this.endDate){
        this.$store.dispatch("get_Knowlarity_data", {
        endDate: this.endDateFormatted,
        startDate: this.startDateFormatted,
        agentNumber: "%2B" + 91 + this.filterAgent,
        offset: this.offset,
        limit: this.limit
        });
      }
    },
    searchAgent(number) {
      var x = this.agents.filter((x) => {
        return x.phone == number;
      });
      if (x.length > 0) {
        return x[0].first_name;
      } else {
        return null;
      }
    },
  },
  computed: {
    offset(){
      // if(this.knowlarityCount){
      //   return Number(this.knowlarityCount.offset) + 50
      // }else{
      //   return 0
      // }
      return 0
    },
    loading() {
      return this.$store.state.makingAJAX;
    },
    knowlarity() {
      return this.$store.state.knowlarity_data.objects
    },
    knowlarityCount() {
      return this.$store.state.knowlarity_data.meta
    },
    agents() {
      return this.$store.state.knowlarity_agents;
    },
    filterByAgent() {
      return this.knowlarity || [];
    },
    endDateFormatted() {
      if (this.endDate) {
        return moment(this.endDate).format("YYYY-MM-DD");
      } else {
        return moment().format("YYYY-MM-DD");
      }
    },
    startDateFormatted() {
      if (this.startDate) {
        return moment(this.startDate).format("YYYY-MM-DD");
      } else {
        return moment().format("YYYY-MM-DD");
      }
    },
  },
};
</script>

<style scoped>
audio {
    height: 25px;
}
.hover:hover{
  background-color: #ce7024;
  color: white;
  cursor: pointer;
  border-radius: 50%;
}
.close-btn{
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 0;
}
.close-btn:hover{
  background-color: #ce7024;
}
.player{
  background-color: #F27F24;
}
.player {
    position: absolute;
    /* height: 100vh; */
    /* overflow: hidden; */
    /* background-color: blue; */
    bottom: 2%;
    right: 2%;
    z-index: 99999;
}
.table-responsive {
  max-height: 500px;
  overflow: scroll;
}
::-webkit-scrollbar{
  display: none;
}
</style>
